import { render, staticRenderFns } from "./ChannelDialog.vue?vue&type=template&id=1dd62bb8&scoped=true"
import script from "./ChannelDialog.vue?vue&type=script&lang=js"
export * from "./ChannelDialog.vue?vue&type=script&lang=js"
import style0 from "./ChannelDialog.vue?vue&type=style&index=0&id=1dd62bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd62bb8",
  null
  
)

export default component.exports